import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import CompactLayout from 'src/layouts/compact';
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// AMPLIFY
const AmplifyLoginPage = lazy(() => import('src/pages/auth/amplify/login'));
const AmplifyNewPasswordPage = lazy(() => import('src/pages/auth/amplify/new-password'));
const AmplifyForgotPasswordPage = lazy(() => import('src/pages/auth/amplify/forgot-password'));
const AmplifyForceChangePasswordPage = lazy(
  () => import('src/pages/auth/amplify/force-change-password')
);
const AmplifyCompanySelectionPage = lazy(() => import('src/pages/auth/amplify/company-selection'));

// ----------------------------------------------------------------------

const authAmplify = {
  path: 'amplify',
  children: [
    {
      element: (
        <GuestGuard>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </GuestGuard>
      ),
      children: [
        {
          path: 'login',
          element: (
            <AuthClassicLayout>
              <AmplifyLoginPage />
            </AuthClassicLayout>
          ),
        },
        {
          element: (
            <CompactLayout>
              <Outlet />
            </CompactLayout>
          ),
          children: [
            { path: 'new-password', element: <AmplifyNewPasswordPage /> },
            { path: 'forgot-password', element: <AmplifyForgotPasswordPage /> },
            { path: 'force-change-password', element: <AmplifyForceChangePasswordPage /> },
          ],
        },
      ],
    },
    {
      path: 'company-selection',
      element: <AmplifyCompanySelectionPage />,
    },
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authAmplify],
  },
];
